// Plural Actions
export const GET_MW_JOBS = "GET_MW_JOBS";
export const getMWJobs = (opts = {}) => {
  const params = opts.refresh ? { refresh: "true" } : {};
  const request = axios.get("/moneyworks/jobs.json", { params });
  return {
    type: GET_MW_JOBS,
    payload: request,
  };
};
